// extracted by mini-css-extract-plugin
export default {"homeDetailPillButtons":"HomeDetail_homeDetailPillButtons__aOzSg"};